module.exports = __webpack_public_path__ + "opensans-semibold.a032a907b90f136788e7.woff";


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/fonts/opensans/opensans-semibold.woff
// module id = ../../../../../www/assets/fonts/opensans/opensans-semibold.woff
// module chunks = styles